import JsonLd from "@/components/base/JsonLd";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import TrustStrip from "./components/TrustStrip";
import AboutSection from "./components/AboutSection";
import ComparisonTable from "./components/ComparisonTable";
import HowItWorks from "./components/HowItWorks";
import BenefitsGrid from "./components/BenefitsGrid";
import CategoryGrid from "./components/CategoryGrid";
import TestimonialSection from "./components/TestimonialSection";
import BlogSection from "./components/BlogSection";
import CTASection from "./components/CTASection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://itaobuy.yachts";
const siteLogo = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "ItaobuySpreadsheet",
  "url": siteUrl,
  "logo": siteLogo,
  "description": "ItaobuySpreadsheet is a next-generation product sourcing system built for dropshippers, Amazon sellers, and global eCommerce buyers.",
  "sameAs": [],
};

const faqPageSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Is ItaobuySpreadsheet free?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It depends on access level, but most sheets are freely structured for browsing. You can explore product categories and supplier data without any upfront payment, making the itaobuy spreadsheet an accessible entry point for new dropshippers and experienced sellers alike."
      }
    },
    {
      "@type": "Question",
      "name": "Is it safe to use ItaobuySpreadsheet?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, absolutely. The itaobuy spreadsheet system only organizes supplier data and product information for comparison purposes. All actual purchases are made through secure third-party platforms, so your payment information and personal details are never stored within the spreadsheet system itself."
      }
    },
    {
      "@type": "Question",
      "name": "Who uses ItaobuySpreadsheet?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Dropshippers, Amazon sellers, Shopify store owners, and global resellers form the core user base. Whether you are running a small boutique shop or managing a large-scale eCommerce operation, the itaobuy spreadsheet provides structured product data that fits your workflow."
      }
    },
    {
      "@type": "Question",
      "name": "How often is the product data updated?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The itaobuy spreadsheet product sheets are refreshed on a regular basis to ensure pricing accuracy and availability data remain current. Most categories see updates weekly, with high-demand categories refreshed even more frequently to keep you ahead of market trends."
      }
    },
    {
      "@type": "Question",
      "name": "Can I request a specific product category?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The current itaobuy spreadsheet already covers 14 major categories from Shoes to Perfumes. If you need a category that is not yet covered, the system is continuously expanding based on buyer demand and market shifts in the global dropshipping landscape."
      }
    }
  ]
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={organizationSchema as Record<string, unknown>} />
      <JsonLd data={faqPageSchema as Record<string, unknown>} />
      <Navbar />
      <main>
        <HeroSection />
        <TrustStrip />
        <AboutSection />
        <ComparisonTable />
        <HowItWorks />
        <BenefitsGrid />
        <CategoryGrid />
        <TestimonialSection />
        <BlogSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}